function Error404Page() {


    return (
        <div>
            <h1>
                404
            </h1>
        </div>
    )
}

export default Error404Page
